export default __webpack_public_path__ + "static/media/default-404.13c0172e.svg";